import React, { useEffect, useState, useRef } from 'react'
import "./SavedRecipientsOverlay.scss";
import { Breadcrumb, BreadcrumbItem } from '@livingdesign/react';
import SavedRecipientsContainer from './SavedRecipientsContainer';
import { useMessageDetailsForm } from '../../../../../../../contexts/MessageDetailsForm';
import EditFormActionsFooter from '../../EditFormActionsFooter';
import { useCampaignContext } from '../../../../../../../contexts/Campaign';
import { useAppContext } from '../../../../../../../contexts/Core';
import { Edit } from '@material-ui/icons';
import { set } from 'lodash';

export const QA_ID_PREFIX = "SavedRecipientsOverlay";

function SavedRecipientsOverlay({
    open,
    handleClose,
    onFilterApplied,
    loading
}) {



    const [selectedFilter, setSelectedFilter] = useState(null);
    const [selectedFilterData, setSelectedFilterData] = useState(null);


    useEffect(() => {
        if(!open) return;
        setSelectedFilter(null);
        // // Clear main page scroll position and prevent body scrolling
        window.scrollTo(0, 0);
        // document.body.style.overflow = 'hidden';
        
        // return () => {
        //     // Restore body scrolling when overlay closes
        //     document.body.style.overflow = 'unset';
        // };
        
    }, [open]);

    if(!open) return null;

    const validateSavedRecipientsStep = () => {
        return selectedFilter !== null;
    };


    const handleApplyFromContainer = (filterData) => {
        // When Apply is clicked from the container, apply the filter and close
        if (onFilterApplied) {
            onFilterApplied(filterData);
        }
        handleClose();
    };

    return (
        <main className='saved-recipients-overlay' data-testid={`${QA_ID_PREFIX}-main`}>
            <div className='saved-recipients-main' data-testid={`${QA_ID_PREFIX}-container`}>
                <Breadcrumb data-testid={`${QA_ID_PREFIX}-breadcrumb`}>
                    <BreadcrumbItem data-testid={`${QA_ID_PREFIX}-breadcrumb-home`}>Home</BreadcrumbItem>
                    <BreadcrumbItem
                        onClick={ ()=> {
                            handleClose();
                        }}
                        data-testid={`${QA_ID_PREFIX}-breadcrumb-create-message`}
                    >
                        Create new message
                    </BreadcrumbItem>
                    <BreadcrumbItem data-testid={`${QA_ID_PREFIX}-breadcrumb-saved-recipients`}>Saved Recipient Filters</BreadcrumbItem>
                </Breadcrumb>
                <div className="saved-recipients-content" data-testid={`${QA_ID_PREFIX}-content-container`}>
                    <section className='saved-recipients-title' data-testid={`${QA_ID_PREFIX}-title-section`}>
                        <h2 data-testid={`${QA_ID_PREFIX}-step-title`}>Choose from your saved recipient filters</h2>
                        <p data-testid={`${QA_ID_PREFIX}-step-description`}>Quickly select from your saved recipient filters to target the right audience without setting criteria from scratch each time.</p>
                    </section>
                    <section data-testid={`${QA_ID_PREFIX}-step-content`}>
                        <SavedRecipientsContainer
                            selectedFilter={selectedFilter}
                            onSelectionChange={({newSelectionFilterId, selectedFilterData})=>{
                                setSelectedFilter(newSelectionFilterId);
                                setSelectedFilterData(selectedFilterData)
                            }}
                            onApply={handleApplyFromContainer}
                        />
                    </section>
                </div>
                <section data-testid={`${QA_ID_PREFIX}-actions-section`}>
                    <EditFormActionsFooter
                        loading={loading}
                        disableContinue={!validateSavedRecipientsStep()}
                        onPrevious={ ()=>{
                            handleClose();
                        }}
                        onSaveDraft={ ()=>{}}
                        onContinue={() => {
                            console.log('selectedrecipientsoverlay onContinue', selectedFilterData)
                            if (selectedFilterData && handleApplyFromContainer) {
                                handleApplyFromContainer(selectedFilterData);
                            }
                        }}
                        data-testid={`${QA_ID_PREFIX}-actions-footer`}
                    />
                </section>
            </div>
        </main>
    )
}

export default SavedRecipientsOverlay;
